// test get
// import { METHOD_POST } from "../utils/const"
export const METHOD_GET = "GET";
export const METHOD_POST = "POST";

// import { SORT_ARRAY } from "../utils/const"
// first element in array is used for default
// export const SORT_ARRAY = [
//     "Purchase - newest first",
//     "Purchase - oldest first",
//     "Creation - newest first",
//     "Creation - oldest first"
// ];

// import { LOCATION_ARRAY } from "../utils/const"
export const LOCATION_ARRAY = [
    "Amsterdam",
    "Brussel",
    "Madrid",
    "New York",
    "Parijs",
    "Singapore"
];

// export const TAB_ARRAY = [
//     'Artist/title',
//     'Type',
//     'Period',
//     'Theme',
//     'Location'
// ];

export const TYPE_ARRAY = [
    'Paintings',
    'Photography',
    'Sculpture',
    'Graphics',
    'Mixed media',
    // 'Work on paper',
    'Video',
    'Other',
    'Commisioned',
];

export const THEME_ARRAY = [
    'The human face',
    'Digital world',
    'Still life',
    'Human vs. Nature',
    'Society & Urban development',
    'Colour & form',
    'Other'
];

export const PERIOD_ARRAY = [
    'Magic realism',
    'CoBrA',
    'Photo realism',
    'Pop-art',
    'North Netherlands figuration',
    'Post-internet',
    'Other',
];

export const SEARCH = {
    ARTIST: 'artist',
    TYPE: 'type',
    PERIOD: 'period',
    PERIODBETWEEN: 'period-between',
    THEME: 'theme',
    LOCATION: 'location',
    SORT: 'sort',
}